import { BookingStrategies } from './types';

export function normalizeUrl(url: string) {
  return url.endsWith('/') ? url : `${url}/`;
}

export function shouldShowScheduleAppointmentsSectionOnMobile(
  bookingStrategy: BookingStrategies
) {
  switch (bookingStrategy) {
    case BookingStrategies.Availability:
      return true;
    case BookingStrategies.OpenSchedulingWidget:
      return true;
    case BookingStrategies.Button:
      return false;
    default:
      return false;
  }
}

interface IsBookingEnabledProps {
  showBookingCtaButton: boolean;
  bookingStrategy: BookingStrategies;
}
/**
 * Only used when `darkship_feature_flags.use_cta_drawer` is enabled.
 * Used to determine if booking section/aside should display on the profile.
 * Availability and OpenSchedulingWidget strategies always enable booking.
 * showBookingCtaButton prop enables booking when the strategy is Button.
 *
 * @param props
 * @param props.bookingStrategy - The strategy used for booking.
 * @param props.showBookingCtaButton - Indicates whether the booking CTA button should be shown.
 * @returns `true` if booking is enabled, otherwise `false`.
 */
export const isBookingEnabled = ({
  bookingStrategy,
  showBookingCtaButton
}: IsBookingEnabledProps) => {
  if (bookingStrategy === BookingStrategies.Button) {
    return showBookingCtaButton;
  }
  return true;
};
